var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3886 10.7543L20.5158 1.49139L20.0316 1L10.9044 10.2629L1.96838 1.1941L1.48419 1.68549L10.4202 10.7543L1 20.3145L1.48419 20.8059L10.9044 11.2457L20.5158 21L21 20.5086L11.3886 10.7543Z",
    fill: "#A180FF",
    stroke: "#A180FF",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPurple);
export default __webpack_public_path__ + "static/media/cross-purple.42cc4e1a2039232749ef90cd4fe8b5b5.svg";
export { ForwardRef as ReactComponent };